// extracted by mini-css-extract-plugin
module.exports = {"container":"run-details_container__3xHI_","title":"run-details_title__bJ4ti","list":"run-details_list__1ev2S"};